import styled from 'styled-components';
import { black } from 'styles/Colors';

export const SectionHeadlineWrapper = styled.div`
  font-family: 'Oswald';
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${black};
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 13px;
`;
